// Translations for Brokers Lounge (EN + AR)
export const translations = {
  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      about: "About",
      portfolio: "Portfolio",
      market: "Market",
      philosophy: "Philosophy",
      contact: "Contact",
      cta: "Enquire",
    },
    hero: {
      eyebrow: "Brokers Lounge — Dubai",
      title_1: "Curating",
      title_2: "Dubai's Finest",
      title_3: "Residential Holdings.",
      subtitle:
        "A private real estate investment house holding a majority residential portfolio across the United Arab Emirates.",
      cta_primary: "Explore Portfolio",
      cta_secondary: "Speak with us",
      scroll: "Scroll",
    },
    stats: {
      eyebrow: "By the numbers",
      items: [
        { value: "15+", label: "Years in Dubai" },
        { value: "AED 2B+", label: "Assets under stewardship" },
        { value: "Majority", label: "Residential portfolio across UAE" },
        { value: "100%", label: "Owner-operated discretion" },
      ],
    },
    about: {
      eyebrow: "About the House",
      title: "A quiet conviction in the architecture of the Emirates.",
      body_1:
        "Brokers Lounge is a privately held real estate investment firm headquartered in Dubai. We own, operate and steward a majority residential building portfolio across the United Arab Emirates — from the canals of Business Bay to the heritage shores of Al Jaddaf.",
      body_2:
        "We do not chase trends. We acquire, hold and improve buildings that endure — assets defined by location, light, and the quality of the lives they make possible.",
      pillars: [
        { title: "Long horizon", body: "Multi-decade hold, never a flip." },
        { title: "Quiet capital", body: "Discreet, principal-only investment." },
        { title: "Operational rigor", body: "In-house management of every asset." },
      ],
    },
    portfolio: {
      eyebrow: "Selected Portfolio",
      title: "Buildings we are proud to call ours.",
      view: "View building",
      items: [
        {
          id: "the-bay",
          name: "The Bay",
          location: "Business Bay, Dubai",
          tag: "Residential Tower",
          note: "A waterfront residence on the Business Bay canal — central, sculpted, and built for long life.",
        },
        {
          id: "spinnaker-residence",
          name: "Spinnaker Residence",
          location: "Al Jaddaf, Dubai",
          tag: "Residential Building",
          note: "A 12-storey residence in Al Jaddaf — close to the Creek, the arts, and the city.",
        },
        {
          id: "battersea-residence",
          name: "Battersea Residence",
          location: "Al Jaddaf, Dubai",
          tag: "Residential Tower",
          note: "A 14-storey residence in Al Jaddaf — completed 2020, designed by Eng. Adnan Saffarini.",
        },
        {
          id: "future",
          name: "Forthcoming Acquisitions",
          location: "Dubai · Abu Dhabi · Sharjah",
          tag: "Under Review",
          note: "We review a small number of opportunities each year. Selectivity is the strategy.",
        },
      ],
    },
    philosophy: {
      eyebrow: "Philosophy",
      title: "We invest in shelter, not in noise.",
      body:
        "Residential real estate is the most human asset class. We hold buildings because people live in them — and because doing so well, over decades, compounds quietly. Our discipline is patience; our edge is the willingness to wait.",
      quote:
        "“The best buildings are not bought. They are kept.”",
    },
    contact: {
      eyebrow: "Contact",
      title: "A conversation, in confidence.",
      body:
        "For acquisitions, tenancy, or institutional enquiries, please write to the office. Every message is read by a principal.",
      name: "Full name",
      email: "Email address",
      phone: "Phone (optional)",
      subject: "Subject (optional)",
      message: "Your message",
      submit: "Send enquiry",
      sending: "Sending…",
      success: "Thank you. Your enquiry has been received.",
      error: "Something went wrong. Please try again.",
      office: "Office",
      office_addr: "Dubai, United Arab Emirates",
      phone_label: "Telephone",
      phone_value: "+971 4 349 9000",
      email_label: "Email",
      email_value: "office@brokerslounge.net",
    },
    footer: {
      tag: "Brokers Lounge — A private real estate house. Dubai, UAE.",
      rights: "All rights reserved.",
      nav: "Navigate",
    },
    market: {
      eyebrow: "Market Pulse · Dubai",
      title: "The latest transactions across Dubai.",
      subtitle:
        "A daily snapshot of recent residential transactions, sourced from the Dubai Land Department open data via propertyfinder.ae.",
      headers: {
        building: "Building",
        location: "Community",
        type: "Type",
        beds: "Beds",
        size: "Size (sq ft)",
        price: "Price (AED)",
        psf: "AED / sq ft",
        date: "Date",
        status: "Status",
      },
      updated: "Last updated",
      source: "Source",
      empty: "No transactions captured yet. Please check back shortly.",
      view_source: "View source",
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      about: "عن الشركة",
      portfolio: "المحفظة",
      market: "السوق",
      philosophy: "الفلسفة",
      contact: "تواصل",
      cta: "استفسار",
    },
    hero: {
      eyebrow: "بروكرز لاونج — دبي",
      title_1: "ننتقي",
      title_2: "أرقى المباني",
      title_3: "السكنية في دبي.",
      subtitle:
        "بيت استثمار عقاري خاص يمتلك محفظة سكنية بأغلبية المباني في دولة الإمارات العربية المتحدة.",
      cta_primary: "تصفح المحفظة",
      cta_secondary: "تواصل معنا",
      scroll: "اسحب للأسفل",
    },
    stats: {
      eyebrow: "بالأرقام",
      items: [
        { value: "+15", label: "عاماً في دبي" },
        { value: "+٢ مليار درهم", label: "أصول تحت الإدارة" },
        { value: "أغلبية", label: "محفظة سكنية في الإمارات" },
        { value: "١٠٠٪", label: "إدارة مالكين بالكامل" },
      ],
    },
    about: {
      eyebrow: "عن البيت",
      title: "قناعة هادئة في عمارة الإمارات.",
      body_1:
        "بروكرز لاونج هي شركة استثمار عقاري خاصة مقرها دبي. نمتلك ونُشغّل ونحافظ على محفظة سكنية بأغلبية المباني في الإمارات — من قنوات الخليج التجاري إلى ضفاف الجداف العريقة.",
      body_2:
        "لا نلاحق الموضات. نقتني المباني التي تدوم — أصول يحددها الموقع والضوء وجودة الحياة التي تتيحها.",
      pillars: [
        { title: "أفق طويل", body: "احتفاظ يمتد لعقود، لا مضاربة." },
        { title: "رأس مال هادئ", body: "استثمار خاص ومباشر فقط." },
        { title: "صرامة تشغيلية", body: "إدارة داخلية لكل أصل." },
      ],
    },
    portfolio: {
      eyebrow: "مختارات من المحفظة",
      title: "مبانٍ نفخر بها.",
      view: "تفاصيل المبنى",
      items: [
        {
          id: "the-bay",
          name: "ذا باي",
          location: "الخليج التجاري، دبي",
          tag: "برج سكني",
          note: "إقامة على القناة المائية في الخليج التجاري — مركزي ومنحوت ومبني للبقاء.",
        },
        {
          id: "spinnaker-residence",
          name: "سبينيكر ريزيدنس",
          location: "الجداف، دبي",
          tag: "مبنى سكني",
          note: "إقامة من ١٢ طابقاً في الجداف — قريبة من الخور ومراكز الفنون والمدينة.",
        },
        {
          id: "battersea-residence",
          name: "باترسي ريزيدنس",
          location: "الجداف، دبي",
          tag: "برج سكني",
          note: "إقامة من ١٤ طابقاً في الجداف — اكتملت ٢٠٢٠، تصميم م. عدنان صفاريني.",
        },
        {
          id: "future",
          name: "صفقات قادمة",
          location: "دبي · أبوظبي · الشارقة",
          tag: "قيد الدراسة",
          note: "ندرس عدداً محدوداً من الفرص كل عام. الانتقاء هو الاستراتيجية.",
        },
      ],
    },
    philosophy: {
      eyebrow: "الفلسفة",
      title: "نستثمر في المأوى، لا في الضجيج.",
      body:
        "العقار السكني هو أكثر الأصول إنسانية. نحتفظ بالمباني لأن الناس يسكنونها — والقيام بذلك جيداً عبر العقود يُراكم بهدوء. انضباطنا هو الصبر، وميزتنا هي الاستعداد للانتظار.",
      quote: "«أفضل المباني لا تُشترى، بل تُحفظ.»",
    },
    contact: {
      eyebrow: "تواصل",
      title: "محادثة بسرية تامة.",
      body:
        "للاستفسارات حول الاستحواذ أو الإيجار أو المؤسسات، يرجى الكتابة إلى المكتب. تُقرأ كل رسالة من قبل أحد الشركاء.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف (اختياري)",
      subject: "الموضوع (اختياري)",
      message: "رسالتك",
      submit: "إرسال الاستفسار",
      sending: "جارٍ الإرسال…",
      success: "شكراً لك. تم استلام استفسارك.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      office: "المكتب",
      office_addr: "دبي، الإمارات العربية المتحدة",
      phone_label: "الهاتف",
      phone_value: "+971 4 349 9000",
      email_label: "البريد",
      email_value: "office@brokerslounge.net",
    },
    footer: {
      tag: "بروكرز لاونج — بيت عقاري خاص. دبي، الإمارات.",
      rights: "جميع الحقوق محفوظة.",
      nav: "التنقل",
    },
    market: {
      eyebrow: "نبض السوق · دبي",
      title: "أحدث المعاملات العقارية في دبي.",
      subtitle:
        "لقطة يومية لأحدث المعاملات السكنية، مصدرها بيانات دائرة الأراضي والأملاك في دبي عبر propertyfinder.ae.",
      headers: {
        building: "المبنى",
        location: "المنطقة",
        type: "النوع",
        beds: "الغرف",
        size: "المساحة (قدم²)",
        price: "السعر (درهم)",
        psf: "درهم / قدم²",
        date: "التاريخ",
        status: "الحالة",
      },
      updated: "آخر تحديث",
      source: "المصدر",
      empty: "لم تُلتقط معاملات بعد. يرجى المعاودة قريباً.",
      view_source: "عرض المصدر",
    },
  },
};

export const getT = (lang) => translations[lang] || translations.en;
